import { useState, useEffect } from 'react';

declare global {
    interface Window {
        CookieInformation: {
            getConsentGivenFor: (cookieCategory: string) => boolean;
        };
    }
}

export function useCookieConsent(cookieCategory = 'cookie_cat_functional') {
    const isCookieInformationUndefined =
        typeof window === 'undefined' || typeof window.CookieInformation === 'undefined';

    function getConsent() {
        if (isCookieInformationUndefined) return false;
        return window.CookieInformation.getConsentGivenFor(cookieCategory);
    }

    const [consent, setConsent] = useState(getConsent());

    useEffect(() => {
        if (isCookieInformationUndefined) {
            console.warn(
                'CookieInformation is not defined on the window object. Ensure that the CookieInformation script is loaded.',
            );
            return;
        }

        const handleConsentChange = () => {
            const updatedConsent = getConsent();
            if (updatedConsent !== consent) {
                setConsent(Boolean(updatedConsent));
            }
        };

        window.addEventListener('CookieInformationConsentGiven', handleConsentChange, false);

        return () => {
            window.removeEventListener('CookieInformationConsentGiven', handleConsentChange, false);
        };
    }, [cookieCategory]);

    return consent;
}
